<template>
    <div class="" id="CarInfo">
        <mt-header fixed title="车辆信息">
            <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
        </mt-header>
        <div class="process">
            <img src="static/image/process@2x.png" alt="">
        </div>
        <div class="line-5"></div>
        <mt-cell title="品牌车系" is-link>
            <span>请选择品牌车系</span>
        </mt-cell>
        <hr>
        <mt-cell title="上牌时间" is-link>
            <span>请选择上牌时间</span>
        </mt-cell>
        <hr>
        <mt-cell title="行驶里程">
            <input type="text" pattern="请输入行驶里程">
            <span>万里</span>
        </mt-cell>
        <hr>
        <mt-cell title="上传图片" is-link>
            <img src="static/image/up_img@2x.png" alt="">
        </mt-cell>
        <div class="but">
            <button>确认提交</button>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem, Header, Cell, DatetimePicker,Indicator } from "mint-ui";
import { API_GET, API_POST, getLocation } from "@/apiConfig";
export default {
    name: "CarInfo",
    data() {
        return {
            msg: "Welcome to Your Vue.js App"
        };
    },
    mounted() {
        console.log(this.$route.params, "this.$route.params");
        this.fetchData();
    },
    methods: {
        goback: function() {
            window.history.go(-1);
        },

        fetchData: function() {
            let body = {
                carId: this.$route.params.id
            };
            if (body.carId != null) {
                this.loading = true;
                Indicator.open();
                API_POST("/car/getCarInfoDetail", body).then(res => {
                    if (res.status == 0) {
                        // this.resList = res.data.list;
                    } else {
                        Toast(res.msg);
                    }
                    Indicator.close();
                });
            }
        },

        onShowSortFlag: function(sortFlag) {
            console.log(sortFlag, "sortFlagsortFlag");
            if (this.sortFlag == sortFlag) {
                this.sortFlag = "";
            } else {
                this.sortFlag = sortFlag;
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.mint-header-button > a {
    color: #2c2c2c;
}
html {
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/CarInfo.vue